import { createContext, useContext } from 'react';

export interface PayPeriodContextType {
    startDate: Date;
    endDate: Date;
}

export const PayPeriodContext = createContext<PayPeriodContextType>(
    undefined as any
);

export default function usePayPeriodContext() {
    const context = useContext<PayPeriodContextType>(PayPeriodContext);

    return context;
}
